export const LOADING_SUFFIX = '__loading';
export const VISIBLE_LIMIT = 5;
export const SHOW_MORE_SUFFIX = '__show_more';
export const ERROR_SUFFIX = '__error';
export const TREE_ID_SEP = '::';
